import {Project} from './project';

export class User {
  _id: string;
  email: string;
  role: string;
  projects: Array<Project> = [];

  constructor(data) {
    this._id = data.id;
    this.role = data.role;
    this.email = data.email;
    this.projects = data.projects ? data.projects.map(project => new Project(project)) : [];
  }

  getObj() {
    return {
      _id: this._id,
      email: this.email,
      role: this.role,
      projects: this.projects.map(project => project.getObj())
    };
  }
}
